__webpack_require__.p = "https://colora-acceptance.vercel.app/_next/";